import { FC } from 'react'
import { Icon } from '@saasalerts/ui'
import { faXmark } from '@awesome.me/kit-e270131d0a/icons/classic/regular'

export const ImagePreview: FC<
  React.PropsWithChildren<{
    src: string
    onRemoveImage: () => void
    alt?: string
    removeTitle?: string
  }>
> = ({ src, onRemoveImage, alt = 'image', removeTitle = 'Remove' }) => (
  <div className="flex pt-4">
    <div className="relative">
      <img className="max-h-24" src={src} alt={alt} />
      <Icon
        icon={faXmark}
        className="absolute right-0 top-0 m-1 size-5 cursor-pointer border-2 bg-white"
        color="inherit"
        title={removeTitle}
        onClick={onRemoveImage}
      />
    </div>
  </div>
)
